export interface AppHeaderState {
  filterCount: number;
  title: string;
}

export const headerInitialState: AppHeaderState = {
  filterCount: 0,
  title: '',
};
